import { useMutation, useQueryClient } from '@tanstack/react-query'
import React from 'react'
import { updateCompSeq as updateCompSeqAPI} from 'services/apiComparable';

const useUpdateSeq = () => {
  const queryClient = useQueryClient();

  const{isPending:isUpdatingSeq,isSuccess:isUpdatedSeq,mutate:updateCompSeq}=useMutation({
    mutationFn: updateCompSeqAPI,
    onMutate: async (newSeqData)=>{
        await queryClient.cancelQueries(['compList'])

        const previousData = queryClient.getQueryData(['compList']);
        queryClient.setQueryData(['compList'],(old)=>
            old?.map(comp=>{
                const updated=newSeqData.find(c=>c.id===comp.id);
                return updated?{...comp,seq:updated.seq}:comp;
            })
        )
        return {previousData}
    },
    onError: (error, _, context) => {
        // Rollback cache to old state
        queryClient.setQueryData(['compList'], context.previousData);

        console.log("Error occurred when updating seq", error);
        if (error?.data && typeof error.data === 'object') {
            for (const key in error.data) {
                const msg = error.data[key];
                toast.error(Array.isArray(msg) ? msg[0] : msg);
            }
        } else {
            toast.error(error.message || "Something went wrong.");
        }
    }

  })
  return{isUpdatingSeq,isUpdatedSeq,updateCompSeq}
}

export default useUpdateSeq